import React, { useEffect, useState } from 'react'
import { One, Two, Three, Four, Five, Six, Seven, Eight, Nine } from 'assets'
import { AvatarCellStyles } from './Style'
import { Img } from 'styles/GlobalStyle'

const AvatarCell = ({ row }) => {
    const avatars = [One, Two, Three, Four, Five, Six, Seven, Eight, Nine]
    const [randomNumber, setRandomNumber] = useState(null);

    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * avatars.length);
        setRandomNumber(randomIndex);
    }, [])

    return (
        <AvatarCellStyles>
            <div className='avatar-img'>
                <Img src={avatars[row.index % 9]} />
            </div>
        </AvatarCellStyles>
    )
}

export default AvatarCell